import {EventManager} from "shared/utilities/Events/EventManager";
import {GetAdvancedField} from "InternalShared/Events/GetAdvancedField";
import {InvoiceDetailField} from "./FieldItems/InvoiceDetailField";
import * as React from "react";
import {GetControlOptions} from "InternalShared/Events/GetControlOptions";
import {PRPDFControlFactory, PRPDFControlOptionsFactory} from "../../PageBuilderPr/PRControlFactory";
import {GetControl} from "InternalShared/Events/GetControl";
import {WPFormControlFactory, WPFormControlOptionsFactory} from "./Controls/WPFormFactory";

EventManager.Subscribe(GetAdvancedField,e=>{
    return[
        <InvoiceDetailField/>
    ]
});


EventManager.Subscribe(GetControlOptions,e=>WPFormControlOptionsFactory.GetControlOptions(e.Type));
EventManager.Subscribe(GetControl,e=>WPFormControlFactory.GetControl(e.Type));